<template>
  <div>
    <loading-spinner v-if="!user" />
    <b-jumbotron v-if="user">
      <b-container>
        <b-row>
          <b-col>
            <h1>
              {{
                user.first_name || getLabel('UNNAMED_USER') || 'Unnamed User'
              }}
              {{ user.last_name }}
            </h1>
            <p class="lead">
              {{ user.email }}
            </p>
            <p>{{ getLabel('USER') }} #{{ user.id }}</p>
          </b-col>
          <b-col
            v-if="
              auth.user.selectedAccess.roleLevel >= 3 &&
                auth.user.selectedAccess.can_manage_users
            "
            class="text-right"
          >
            <b-button variant="danger" @click="deleteUser()">
              <span v-label-key="'DELETE_USER'">Delete User</span>
            </b-button>
            <b-button
              v-router-link="{ name: 'user-editor', query: { id: user.id } }"
              variant="primary"
              class="ml-2"
            >
              <span v-label-key="'EDIT_USER'">Edit User</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-jumbotron>
    <b-container v-if="user">
      <h3 v-label-key="'ROLES'">Roles</h3>
      <b-table-simple striped>
        <b-thead>
          <b-tr>
            <b-th><span v-label-key="'ORGANIZATION'">Organization</span></b-th>
            <b-th
              ><span v-label-key="'MODIFY_SETTINGS'"
                >Modify Settings</span
              ></b-th
            >
            <b-th><span v-label-key="'VIEW_REPORTS'">View Reports</span></b-th>
            <b-th><span v-label-key="'MANAGE_USERS'">Manage Users</span></b-th>
            <b-th><span v-label-key="'MANAGE_STAFF'">Manage Staff</span></b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="role in user.roles" :key="role.id">
            <b-td @click="editRole(role)">
              {{ role.name || 'GoKaizen' }} ({{ roleName(role.role) }})
            </b-td>
            <b-td>{{
              role.can_modify_settings ? getLabel('YES') : getLabel('NO')
            }}</b-td>
            <b-td>{{
              role.can_view_reports ? getLabel('YES') : getLabel('NO')
            }}</b-td>
            <b-td>{{
              role.can_manage_users ? getLabel('YES') : getLabel('NO')
            }}</b-td>
            <b-td>{{
              role.can_manage_staff ? getLabel('YES') : getLabel('NO')
            }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-button variant="primary" @click="newGrant()">
        <span v-label-key="'ADD_ROLE'">Add Role</span>
      </b-button>
    </b-container>
    <b-modal
      ref="userModal"
      class="modal"
      role="dialog"
      :title="getLabel('ADD_EDIT_ACCESS')"
    >
      <div v-if="activeGrant">
        <b-form>
          <!-- <div class="form-group">
                  <label>Email</label>
                  <input type="email" class="form-control" v-model="activeGrant.email" required>
              </div> -->

          <label v-if="activeGrant.id" v-label-key="'ORGANIZATION'"
            >Organization</label
          ><br />
          <div v-if="activeGrant.id" class="form-control">
            {{ activeGrant.name || 'GoKaizen' }} ({{
              roleName(activeGrant.role)
            }})
          </div>

          <div v-if="!activeGrant.id">
            <label v-label-key="'ACCESS_SELECT_ORANIZATION_SUPERADMIN'"
              >Select between organization or superadmin access</label
            >
            <b-form-select v-model="selected">
              <b-form-select-option :value="null">
                <span v-label-key="'SELECT_AN_OPTION'">Select an option</span>
              </b-form-select-option>
              <b-form-select-option value="organization">
                <span v-label-key="'ORGANIZATION'">Organization</span>
              </b-form-select-option>
              <b-form-select-option value="superadmin">
                <span v-label-key="'SUPERADMIN'">Superadmin</span>
              </b-form-select-option>
            </b-form-select>
            <label
              v-if="selected == 'organization'"
              v-label-key="'ORGANIZATION'"
              >Organization</label
            >
            <vue-bootstrap-typeahead
              v-if="selected == 'organization'"
              v-model="selectedOrg"
              :data="autocomplete"
              :serializer="s => `${s.name} (${roleName(s.type)})`"
              @hit="orgSelected"
            />
          </div>
          <label class="form-check">
            <input
              v-model="activeGrant.can_modify_settings"
              type="checkbox"
              class="form-check-input"
            />
            <span class="form-check-label" v-label-key="'CAN_MODIFY_SETTINGS'"
              >Can Modify Settings</span
            >
          </label>

          <label class="form-check">
            <input
              v-model="activeGrant.can_manage_users"
              type="checkbox"
              class="form-check-input"
            />
            <span class="form-check-label" v-label-key="'CAN_MANAGE_USERS'"
              >Can Manage Users</span
            >
          </label>

          <label class="form-check">
            <input
              v-model="activeGrant.can_manage_staff"
              type="checkbox"
              class="form-check-input"
            />
            <span class="form-check-label" v-label-key="'CAN_MANAGE_STAFF'"
              >Can Manage Staff</span
            >
          </label>
        </b-form>
      </div>
      <div v-if="activeGrant" slot="modal-footer">
        <b-button
          v-if="activeGrant.id"
          variant="danger"
          class="mr-2"
          @click="removeAccess()"
        >
          <span v-label-key="'REMOVE_ACCESS'">Remove Access</span>
        </b-button>
        <b-button
          v-if="activeGrant.id"
          variant="primary"
          @click="modifyAccess()"
        >
          <span v-label-key="'SAVE_CHANGES'">Save Changes</span>
        </b-button>
        <b-button
          v-if="!activeGrant.id"
          variant="primary"
          @click="grantAccess()"
        >
          <span v-label-key="'GRANT_ACCESS'">Grant Access</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import $api from '@/services/api';
import $auth from '@/services/auth';
import LoadingSpinner from '@/components/LoadingSpinner';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import { mapGetters } from 'vuex';

const roleMap = {
  superadmin: 'SUPERADMIN',
  distributor: 'DISTRIBUTOR',
  subdistributor: 'SUBDISTRIBUTOR',
  chain: 'CHAIN',
  store: 'STORE',
};

export default {
  components: {
    LoadingSpinner,
    VueBootstrapTypeahead,
  },
  data() {
    return {
      user: null,
      auth: $auth,
      activeGrant: null,
      selectedOrg: null,
      selected: null,
    };
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
    autocomplete() {
      return this.$store.state.global.autocomplete;
    },
    roleName() {
      return role => {
        if (!role) return '';
        return this.getLabel(roleMap[role]);
      };
    },
  },
  created() {
    this.refreshData();
  },
  methods: {
    orgSelected(selectedOrg) {
      this.activeGrant.role = selectedOrg.type;
      if (selectedOrg.type === 'distributor') {
        this.activeGrant.distributor_id = selectedOrg.id;
      }
      if (selectedOrg.type === 'subdistributor') {
        this.activeGrant.subdistributor_id = selectedOrg.id;
      }
      if (selectedOrg.type === 'chain') {
        this.activeGrant.chain_id = selectedOrg.id;
      }
      if (selectedOrg.type === 'store') {
        this.activeGrant.store_id = selectedOrg.id;
      }
    },
    refreshData() {
      $api
        .get(`/v1/dashboard/dashboardusers/${this.$route.params.id}`)
        .then(user => {
          this.user = user;
        });
    },
    deleteUser() {
      $api
        .delete(`/v1/dashboard/dashboardusers/${this.$route.params.id}`)
        .then(() => {
          this.$router.push({
            name: 'user-list',
          });
        });
    },
    editRole(role) {
      if (this.auth.user.selectedAccess.can_manage_users) {
        this.activeGrant = role;
        this.$refs.userModal.show();
      }
    },
    removeAccess() {
      $api
        .delete(`/v1/dashboard/accessgrants/${this.activeGrant.id}`)
        .then(this.refreshData);
      this.$refs.userModal.hide();
    },
    grantAccess() {
      console.log(this.selectedOrg);
      if (this.selected === 'superadmin') {
        this.activeGrant.role = 'superadmin';
      }
      $api
        .post('/v1/dashboard/accessgrants', this.activeGrant)
        .then(this.refreshData);
      this.$refs.userModal.hide();
    },
    modifyAccess() {
      $api
        .put(
          `/v1/dashboard/accessgrants/${this.activeGrant.id}`,
          this.activeGrant
        )
        .then(this.refreshData);
      this.$refs.userModal.hide();
    },
    newGrant() {
      this.activeGrant = {
        email: this.user.email,
      };
      this.$refs.userModal.show();
    },
  },
};
</script>
